import script from "./BasePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePopup.vue?vue&type=script&setup=true&lang=js"

import "./BasePopup.vue?vue&type=style&index=0&id=5f93a91e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f93a91e"]])

export default __exports__